import { doc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { db } from "../../utils/firebase";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import CryptoJS from 'crypto-js';

const ChangePasswordModal = ({ isOpen, onClose, password, email }) => {
  //console.log("email,", email)
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;


const encryptPassword = (password) => {
    return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if(oldPassword !== password){
      toast.error("Old passwords do not match!");
      return;
    }

    if(newPassword?.length < 6){
      toast.error("Password length must be more than 6")
    }

    if (newPassword !== confirmPassword) {
      toast.error("password should be equal to confirm password!");
      return;
    }

    try {
      setLoading(true);
      const userDocRef = doc(db, "userDetails", email);
      await updateDoc(userDocRef, { password: encryptPassword(newPassword)});
      toast.success("Password updated successfully!");
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error('Something went wrong, please try again later');
    }finally {
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("")
      setLoading(false);
      setTimeout(() => {
        onClose();
      }, 1000)


    }

  };

  if (!isOpen) return null;
  //console.log("decryoted password", password)
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:m-0">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700">✕</button>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Change Password</h2>
        <form onSubmit={handleChangePassword}>
          
          {/* Old Password */}
          <div className="relative">
            <input
              type={showOldPassword ? "text" : "password"}
              placeholder="Old Password"
              className="w-full p-3 border rounded-lg mb-3 pr-10"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
            <span className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowOldPassword(!showOldPassword)}>
              {showOldPassword ?  <FaEye className="text-gray-500"/> : <FaEyeSlash className="text-gray-500"/> }
            </span>
          </div>

          {/* New Password */}
          <div className="relative">
            <input
              type={showNewPassword ? "text" : "password"}
              placeholder="New Password"
              className="w-full p-3 border rounded-lg mb-3 pr-10"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowNewPassword(!showNewPassword)}>
              {showNewPassword ?<FaEye className="text-gray-500"/> :  <FaEyeSlash className="text-gray-500"/>}
            </span>
          </div>

          {/* Confirm Password */}
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              className="w-full p-3 border rounded-lg mb-3 pr-10"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              {showConfirmPassword ? <FaEye className="text-gray-500"/> : <FaEyeSlash className="text-gray-500"/>}
            </span>
          </div>

          <button disabled={loading} type="submit" className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700">
            Update Password
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ChangePasswordModal;
